<template>
  <div class="listing-page">
    <header class="header">
      <div class="row">
        <div class="columns small-12 medium-8">
          <div class="text-unit-plan subheader">
            Premium Classroom-ready Unit &amp; Lesson Plans
          </div>
          <h1>{{ title }}</h1>
          <p>
            {{ description }}
            <nuxt-link :to="localePath('/lesson-plans/')" title="View lesson plans">
              View lesson plans &rarr;
            </nuxt-link>
          </p>
        </div>
      </div>
    </header>

    <resources-list :pagination="true" :params="params" :available-filters="availableFilters" />
  </div>
</template>

<script>
/* Unit Plans
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components: ResourcesList
 * @methods:
 */

import ResourcesList from '~/components/resource/ResourcesList.vue';

export default {
  name: 'UnitPlansIndex',
  components: {
    ResourcesList,
  },
  data() {
    return {
      title: 'Unit Plans',
      subtitle: 'Unit Plans',
      description:
        'A growing collection of time-saving, in-depth Unit Plans, complete with engaging lessons and ready-to-use teaching resources.',
      params: {
        country: this.$i18n.locale,
        orderBy: 'created',
        order: 'desc',
        payload: 'basic',
        perPage: 30,
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        types: ['unit-plan'],
      },
      availableFilters: [
        'learning_areas',
        'year_levels',
        'availability',
        'file_formats',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title + ' - Curriculum Aligned' },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
};
</script>
